// axios全局配置，包括验证检验及错误处理
import axios from 'axios'
import qs from 'qs'
import store from '../store'
import {
    Message,
    MessageBox
} from 'element-ui'
import {
    getToken
} from '@/libs/cookieUtil'
import router from '../router'

let baseURL = process.env.NODE_ENV == "production" ? Global.BASEURL : "/apis";

// let baseURL = 'https://remote.leosys.com.cn/bwg'

// if (process.env.NODE_ENV === 'development') { // 开发环境
//   // baseURL = 'http://localhost'
//   baseURL = 'https://remote.leosys.com.cn/bwg'
// } else { // 编译环境
//   baseURL = Global.BASEURL // 在这里使用配置文件中的域名
// }



// 请求超时重新请求次数，请求间隙
axios.defaults.retry = 3
axios.defaults.retryDelay = 1000
axios.defaults.withCredentials = true;


// 超时设置
const service = axios.create({
    baseURL: baseURL,
    // baseURL: '/api',
    timeout: 300000,
    withCredentials: true,
    crossDomain: true
})


// http request 拦截器
service.interceptors.request.use(
    config => {
        // 每次请求都为http头增加Authorization字段，其内容为token
        if (getToken()) {
            config.headers['Authorization'] = 'Bearer ' + getToken();
            config.headers['party'] = sessionStorage.getItem('party') ? sessionStorage.getItem('party') : 2
        }
        config.headers['Content-Type'] = config.contentType != "" && config.contentType != undefined ? config.contentType : 'application/json;charset=UTF-8'
        config.method == "get" ? config.params = qs.stringify({
            ...config.data
        }) : config.data = config.data;
        if (config.responseType != "" && config.responseType != undefined) {
            config.responseType = config.responseType;
        }
        return config
    },
    err => {
        return Promise.reject(err)
    }
)

service.interceptors.response.use(
    response => {
        if (response.status != 200) {
            Message.error('接口响应失败!')
        } else {
            let data = response.data;
            if (data.code == 20003) {
                store.dispatch('logout').then((value) => {
                    if (value) {
                        router.push({
                            name: 'login',
                            params: {
                                logout: true
                            }
                        })
                    }
                });
            } else {
                data["content"] = data.data;
                return data
            }
        }
    },
    err => { // 请求超时，设置重新请求及错误提示
        let error = JSON.parse(JSON.stringify(err))
            // console.log(error)
        if ((error && error.stack.indexOf('401') > -1) || (error && error.message.indexOf('401') > -1)) {
            store.dispatch('logout').then((value) => {
                if (value) {
                    router.push({
                        name: 'login',
                        params: {
                            logout: true
                        }
                    })
                }
            });
        } else if (error && error.stack.indexOf('timeout') > -1) {
            Message.error('接口响应超时!')
        } else {
            Message.error('接口响应异常!')
        }
        return Promise.reject(error)
    }
)

export default service


// WEBPACK FOOTER //
// ./src/libs/axios.js